import { ModuleFE_Advisor_Resource } from '@app/advisor-frontend';
import { ModuleFE_Advisor_Action } from '@app/advisor-frontend';
import { ResourceType_Consultations, ResourceType_EKG, ResourceType_Imaging } from '@app/hcs-shared';
import { MUSTNeverHappenException } from '@nu-art/ts-common';
export const getOrderResourceType = (order) => {
    if (!ModuleFE_Advisor_Action.is.order(order))
        return 'general';
    if (order.subType === 'treatment')
        return 'treatment';
    const resource = ModuleFE_Advisor_Resource.cache.unique(order.resourceId);
    if (!resource)
        throw new MUSTNeverHappenException(`Could not get resource for id ${order.resourceId}`);
    if (resource.label === ResourceType_EKG)
        return 'ekg';
    switch (resource.type) {
        case ResourceType_Imaging:
            return 'imaging';
        case ResourceType_Consultations:
            return 'consult';
        default:
            return 'general';
    }
};
//# sourceMappingURL=get-resource-type.js.map